import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { Row } from '@/main/utils/table';
import { DropdownItem } from '@/main/store/@types/dropdown.d';
import { NAME as name, CRUMB_LABEL_KEY , DEFAULT_ID} from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		WarehouseId: [] as DropdownItem[], 
		WorkshopId:[] as DropdownItem[],
		UploadWarehouseId:[] as DropdownItem[],
	},
	filter: {
		BulkInventoryPrp: null as boolean | null,
	},
	tableSetting: {
		isEditable: true,
	},
	
	localState: {
			WarehouseId: 0 as number,
			UploadWarehouseId: 0 as number,
			WorkshopId: DEFAULT_ID as number | null,
			pageLoaded: false as boolean,
			defaultRowModel: { cells: {} },
			rowIndex: null as number | null,
			row: {} as Row,
			uniqueRowIndex: 0 as number | null,
			deepCopiedTableRows: [] as Row[],
			dialog: {
				visible: false,
				title: 'cmdPrevod',  
				ID : null as number | null
			},
		},
	rowDetail: null,
	extraActions: {
		
		},
	extraGetters: {},
	extraMutations: {},
	props: {
		ReturnStatus: null as number | null,
		RejectedComments: '' as string,
		Remarks: null as string | null,
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
